import { bridgeApi } from '../network'
import { NewPaymentDetails, PaymentDetails } from './types'

export const getPaymentDetails = async () => {
  const { data } = await bridgeApi.get<PaymentDetails>(
    '/api/v1/sub-agents/me/payment/details'
  )
  return data.data
}

export const submitPaymentDetails = async (
  paymentDetails: NewPaymentDetails
) => {
  const { data } = await bridgeApi.post(
    '/api/v1/sub-agents/me/payment/details',
    paymentDetails
  )
  return data
}
